/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css, html, TemplateResult } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import styles from './content-block-media.scss';
import C4DContentGroup from '../content-group/content-group';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { prefix, stablePrefix: c4dPrefix } = settings;

/**
 * Content block media.
 *
 * @element c4d-content-block-media-content
 */
@customElement(`${c4dPrefix}-content-block-media-content`)
class C4DContentBlockMediaContent extends StableSelectorMixin(C4DContentGroup) {
  protected _renderInnerBody(): TemplateResult | string | void {
    const { _hasContent: hasContent, _hasMedia: hasMedia } = this;
    // Moves media content out of `<div class="cds--content-block__children">`
    return html`
      ${this._renderMedia()}
      <div
        ?hidden="${!hasContent && !hasMedia}"
        class="${prefix}--content-block__children">
        ${this._renderContent()}
      </div>
    `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--content-block-media-content`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The content-block-media-content component has been deprecated in favor of the content-section/block content component. ' +
    'See content-section/block documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentBlockMediaContent;
